function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const COLUMN_1 = {
  title: {
    intlKey: 'prime',
    url: 'https://www.coinbase.com/institutional'
  },
  links: [{
    intlLabelKey: 'tradingAndFinancing',
    intlDescriptionKey: 'tradingAndFinancingDescription',
    intlLinkTitleKey: 'tradingAndFinancingLinkTitle',
    intlIconAltTextKey: 'tradingAndFinancingIconAltText',
    url: 'https://www.coinbase.com/prime/financing',
    iconType: 'pictogram',
    iconName: 'primeNavigation'
  }, {
    intlLabelKey: 'custody',
    intlDescriptionKey: 'custodyDescription',
    intlLinkTitleKey: 'custodyLinkTitle',
    intlIconAltTextKey: 'custodyIconAltText',
    url: 'https://www.coinbase.com/prime/custody',
    iconType: 'pictogram',
    iconName: 'custodyNavigation'
  }, {
    intlLabelKey: 'staking',
    intlDescriptionKey: 'stakingDescription',
    intlLinkTitleKey: 'stakingLinkTitle',
    intlIconAltTextKey: 'stakingIconAltText',
    url: 'https://www.coinbase.com/staking',
    iconType: 'pictogram',
    iconName: 'earnNavigation'
  }, {
    intlLabelKey: 'onchainWallet',
    intlDescriptionKey: 'onchainWalletDescription',
    intlLinkTitleKey: 'onchainWalletLinkTitle',
    intlIconAltTextKey: 'onchainWalletIconAltText',
    url: 'https://www.coinbase.com/prime/onchain-wallet',
    iconType: 'pictogram',
    iconName: 'blockchainConnection'
  }]
};
const COLUMN_2 = {
  title: {
    intlKey: 'markets'
  },
  links: [{
    intlLabelKey: 'exchange',
    intlDescriptionKey: 'exchangeDescription',
    intlLinkTitleKey: 'exchangeLinkTitle',
    intlIconAltTextKey: 'exchangeIconAltText',
    url: 'https://www.coinbase.com/exchange',
    iconType: 'spotIcon',
    iconName: 'exchangeProduct'
  }, {
    intlLabelKey: 'internationalExchange',
    intlDescriptionKey: 'internationalExchangeDescription',
    intlLinkTitleKey: 'internationalExchangeLinkTitle',
    intlIconAltTextKey: 'internationalExchangeIconAltText',
    url: 'https://www.coinbase.com/international-exchange',
    iconType: 'pictogram',
    iconName: 'globalTransactions'
  }, {
    intlLabelKey: 'derivativesExchange',
    intlDescriptionKey: 'derivativesExchangeDescription',
    intlLinkTitleKey: 'derivativesExchangeLinkTitle',
    intlIconAltTextKey: 'derivativesExchangeIconAltText',
    url: 'https://www.coinbase.com/derivatives',
    iconType: 'pictogram',
    iconName: 'derivativesNavigation'
  }, {
    intlLabelKey: 'verifiedPools',
    intlDescriptionKey: 'verifiedPoolsDescription',
    intlLinkTitleKey: 'verifiedPoolsLinkTitle',
    intlIconAltTextKey: 'verifiedPoolsIconAltText',
    url: 'https://www.coinbase.com/verified-pools',
    iconType: 'pictogram',
    iconName: 'verifiedPools'
  }]
};
const PRODUCT_LIST = [COLUMN_1, COLUMN_2];
const EXCLUDED_UK_LABELS = new Set(['staking']);

// Move private client from individuals to businesses for UK users as per UK FinProm compliance request.
const PRODUCT_LIST_UK = [_objectSpread(_objectSpread({}, COLUMN_1), {}, {
  links: [...COLUMN_1.links.filter(link => !EXCLUDED_UK_LABELS.has(link.intlLabelKey)), {
    intlLabelKey: 'privateClient',
    intlDescriptionKey: 'privateClientDescription',
    intlLinkTitleKey: 'privateClientLinkTitle',
    intlIconAltTextKey: 'privateClientIconAltText',
    url: 'https://www.coinbase.com/private-client',
    iconType: 'pictogram',
    iconName: 'primeNavigation'
  }]
}), _objectSpread(_objectSpread({}, COLUMN_2), {}, {
  links: COLUMN_2.links.filter(link => !EXCLUDED_UK_LABELS.has(link.intlLabelKey))
})];
export { COLUMN_1, COLUMN_2, PRODUCT_LIST, PRODUCT_LIST_UK };
//# sourceMappingURL=constants.js.map
